import PauseIcon from 'assets/icons/PauseIcon.svg';
import PlayIcon from 'assets/icons/PlayIcon.svg';
import styled, { keyframes } from 'styled-components/macro';

export const SoundPlayerWrapper = styled.div`
  width: 355px;
  height: 60px;
  padding: 7px 10px 7px 10px;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(9.7px);
  backdrop-filter: blur(9.7px);
  background-color: #ffffff30;

  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 82%;
    max-width: 355px;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
  `};
`;

export const PlayPauseButtonWrapper = styled.div`
  cursor: pointer;
  height: 40px;
  width: 40px;
  border-radius: 35px;
  border: 2px solid ${({ theme }) => theme.text1};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    & > div {
      transform: scale(0.9);
    }
  }
`;

export const PlayPauseImg = styled.div<{ playing: boolean }>`
  height: ${({ playing }) => (playing ? `20px` : `20px`)};
  width: ${({ playing }) => (playing ? `20px` : `20px`)};
  margin-left: ${({ playing }) => (playing ? `0px` : `3px`)};
  background-image: ${({ playing }) => (playing ? `url(${PauseIcon})` : `url(${PlayIcon})`)};
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${({ playing }) => (playing ? `20px 20px` : `20px 20px`)};
  transition: all 0.1s ease-in-out;

  /* ${({ theme, playing }) => theme.mediaWidth.upToMedium`
      background-size: ${playing ? `42px 33px` : `32px 32px`};
  `};*/
`;

export const AudioTitleWrapper = styled.div`
  padding: 0 15px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0 5px 0 10px;
  `};
`;
export const AudioTitle = styled.h3`
  font-family: 'Presicav';
  font-weight: bold;
  padding: 0 0 7px;
  margin: 0;
  font-size: 16px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0 0 4px;
    font-size: 13px;
  `};
`;
export const AudioSubTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Presicav';
  font-size: 11px;

  svg {
    margin-right: 5px;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 9px;
  `};
`;

export const AudioWaves = styled.div`
  margin-left: auto;
  margin-right: 5px;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0 0 4px;
  margin-right: 0px;
    font-size: 14px;
  `};
`;

const growVerticaly = (h: number) => keyframes`
    0% {
      height: 7px; 
    }
    50% {
      height: ${h}px; 
    }
    100% {
      height: 7px; 
    }
`;

export const AudioWave = styled.div<{ sizeMax: number; isPlaying: boolean; animationTime: number }>`
  height: 7px;
  width: 7px;
  margin: 0 2px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.text1};
  animation: ${({ sizeMax, isPlaying }) => growVerticaly(isPlaying ? sizeMax : 7)}
    ${({ animationTime }) => animationTime}s linear;
  animation-iteration-count: infinite;
`;
